import { Input } from '@/components/ui/input';
import { COUNTRY_CODES, formatUSNumber, parsePhone, composePhone } from '@/lib/phone';

interface Props {
  id?: string;
  value: string;
  onChange: (value: string) => void;
}

/**
 * PhoneInput — country-code dropdown (defaults to US +1) + national number.
 * US numbers auto-format to (XXX) XXX-XXXX as you type; the composed value
 * ("+1 (918) 555-0101") is the platform-wide standard.
 */
export function PhoneInput({ id, value, onChange }: Props) {
  const { countryCode, national } = parsePhone(value);

  return (
    <div className="flex gap-2">
      <select
        aria-label="Country code"
        className="flex h-9 w-24 rounded-md border border-input bg-transparent px-2 py-1 text-sm shadow-sm"
        value={COUNTRY_CODES.some((c) => c.code === countryCode) ? countryCode : '+1'}
        onChange={(e) => onChange(composePhone(e.target.value, national))}
      >
        {COUNTRY_CODES.map((c) => (
          <option key={c.code} value={c.code}>
            {c.label}
          </option>
        ))}
      </select>
      <Input
        id={id}
        type="tel"
        placeholder={countryCode === '+1' ? '(918) 555-0101' : 'Phone number'}
        value={countryCode === '+1' ? formatUSNumber(national) : national}
        onChange={(e) => onChange(composePhone(countryCode, e.target.value))}
      />
    </div>
  );
}
